<!--
  PURPOSE LINKS (June '26) — preview of the purpose invite email (review/referral request):
  brand bar, logo, greeting, intro line and ONE centered CTA button instead of the 0-10/star
  rating buttons (mirrors emailTemplates/html/feedbackinvitePurpose.html in the functions).
-->
<template>
    <div>
        <div style="height: 4px; " :style="{backgroundColor: colorHex.hex}"></div>
        <img class="pt_logo" style="margin: 30px auto 30px auto; display: block; height: 40px;" :src="logoUrl" v-if="logoUrl">
        <p style="margin: 20px auto 10px auto; display: block; text-align: center; font-size: 20px; font-weight: 600;" v-if="!logoUrl">{{ $store.state.dash.viewData.business.businessName }}</p>
        <p style="padding: 0 5px; margin: 15px 0; font-size: 16px;">[Customer greeting if applicable],</p>
        <p style="padding: 0 5px; margin: 15px 0 20px 0; font-size: 16px; max-width:800px;">{{ introText }}</p>
        <!-- referral request only: the program's live rewards + matching terms (mirrors the sent email) -->
        <div v-if="referralRewardLines.length" style="padding: 0 5px; margin: 0 0 20px 0;">
          <p v-for="(line, i) in referralRewardLines" :key="i" style="margin: 8px 0; font-size: 16px; font-weight: 600;"><span :style="{color: colorHex.hex}">&#10003;</span>&nbsp;&nbsp;{{ line }}</p>
        </div>
        <div style="min-width: 310px; padding: 50px 0; background-color: #F7F7F7; font-family: 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif';text-align: center;">
          <a target="_blank" :style="{backgroundColor: colorHex.hex}" style="text-decoration: none; color: white; border-radius: 5px; display: inline-block; padding: 14px 38px; font-size: 18px; font-weight: 600; -moz-box-shadow: 1px 2px 4px 0 rgba(0, 0, 0, 0.4); -webkit-box-shadow: 1px 2px 4px 0 rgba(0, 0, 0, 0.4); box-shadow: 1px 2px 4px 0 rgba(0, 0, 0, 0.4);">{{ ctaText }}</a>
        </div>
        <p v-if="referralTerms" style="padding: 0 5px; margin: 15px 0; font-size: 12px; color: #888888; max-width: 800px;">{{ referralTerms }}</p>
        <div v-if="!$store.getters['dash/isAgencyClientParentEID']" style="text-align: right; background: white; font-family: 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'; border-top: 1px solid #DFDFDF;"><a style="color: gray; text-decoration: none; padding: 0 6px; margin: 10px 0 0 0; display: inline-block; font-size: 14px;" target="_blank">Powered by Feedback Link</a><a style="color: gray; text-decoration: none; font-size: 14px; padding: 0 6px; margin: 10px 0 0 0; display: inline-block; border-left: 1px solid gray;"
            target="_blank">Privacy</a>
        </div>
    </div>
</template>


<script>

//EN fallbacks: custom (cloned) language packs never receive keys added after cloning,
//so every new purpose key must degrade to English here, like the backend's lp() helper
const EN_FALLBACKS = {
  purposeReviewEmailIntro: 'Thanks for choosing [businessname]. Would you take a moment to leave us a review? It only takes a minute and it means a lot.',
  purposeReviewEmailCTA: 'Leave a review',
  purposeReferralEmailIntro: 'Thanks for being a customer of [businessname]. If you know someone who’d love us too, we’d be delighted to meet them.',
  purposeReferralEmailCTA: 'Share with a friend',
  referralFriendGets: 'Your friend gets: [reward]',
  referralYouGet: 'You get: [reward]',
  referralTermsOnce: 'Your friend’s gift is redeemable on their first visit. Your reward unlocks once your first referred friend becomes a customer with us — your reward code will be emailed to you when that happens. Rewards aren’t transferable or redeemable for cash.',
  referralTermsEveryFriend: 'Your friend’s gift is redeemable on their first visit. You earn a reward for every friend who becomes a customer with us — each reward code is emailed to you when that happens. Rewards aren’t transferable or redeemable for cash.',
  referralTermsOneSided: 'Your friend’s gift is redeemable on their first visit. Gifts aren’t transferable or redeemable for cash.',
  referralTermsReferrerOnce: 'Your reward unlocks once your first referred friend becomes a customer with us — your reward code will be emailed to you when that happens. Rewards aren’t transferable or redeemable for cash.',
  referralTermsReferrerEvery: 'You earn a reward for every friend who becomes a customer with us — each reward code is emailed to you when that happens. Rewards aren’t transferable or redeemable for cash.',
  referralTermsNoReward: 'We’ll only use your friend’s details to welcome them to [businessname]. No spam, ever.'
}

export default {
    props: {
      purpose: {
            type: String,
            default: 'review' //'review' | 'referral'
      }
    },
    computed: {
        colorHex() {
            return this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.backgroundHex
        },
        logoUrl() {
            return this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.logoUrl
        },
        introText() {
            const key = this.purpose === 'referral' ? 'purposeReferralEmailIntro' : 'purposeReviewEmailIntro'
            return this.lp(key).replace(/\[businessname\]/g, this.$store.state.dash.viewData.business.businessInfo.businessName)
        },
        ctaText() {
            const key = this.purpose === 'referral' ? 'purposeReferralEmailCTA' : 'purposeReviewEmailCTA'
            return this.lp(key)
        },
        //referral request only: same per-side reward gating as the backend senders — each
        //reward is independently optional, so the preview only promises what's configured
        referralRewardLines() {
            if (this.purpose !== 'referral') return []
            const rs = this.$store.state.dash.viewData.business.referralSettings
            if (!rs || rs.enabled !== true) return []
            const lines = []
            if (typeof rs.friendReward === 'string' && rs.friendReward.trim() !== '') lines.push(this.lp('referralFriendGets', { reward: rs.friendReward.trim() }))
            if (rs.twoSided === true && typeof rs.referrerReward === 'string' && rs.referrerReward.trim() !== '') lines.push(this.lp('referralYouGet', { reward: rs.referrerReward.trim() }))
            return lines
        },
        referralTerms() {
            if (this.purpose !== 'referral') return false
            const rs = this.$store.state.dash.viewData.business.referralSettings
            if (!rs || rs.enabled !== true) return false
            const friendRewardConfigured = typeof rs.friendReward === 'string' && rs.friendReward.trim() !== ''
            const referrerRewardConfigured = rs.twoSided === true && typeof rs.referrerReward === 'string' && rs.referrerReward.trim() !== ''
            return (friendRewardConfigured && referrerRewardConfigured)
                ? (rs.rewardEveryFriend === true ? this.lp('referralTermsEveryFriend') : this.lp('referralTermsOnce'))
                : friendRewardConfigured
                ? this.lp('referralTermsOneSided')
                : referrerRewardConfigured
                ? (rs.rewardEveryFriend === true ? this.lp('referralTermsReferrerEvery') : this.lp('referralTermsReferrerOnce'))
                : this.lp('referralTermsNoReward', { businessname: this.$store.state.dash.viewData.business.businessInfo.businessName })
        }
    },
    methods: {
        lp(key, tokens) {
            const pack = this.$store.getters['dash/currentLanguagePack']
            let s = (pack && typeof pack[key] === 'string' && pack[key].trim() !== '') ? pack[key] : EN_FALLBACKS[key]
            if (tokens) Object.keys(tokens).forEach((t) => { s = s.split(`[${t}]`).join(tokens[t]) })
            return s
        }
    }
}

</script>


<style>

</style>
